import { useQuery } from '@tanstack/react-query';
import { getInsuranceStats } from '../api';
import { INSURANCE_QUERY_KEY } from '../constants';
import { InsuranceFilterParams } from '../model';

export const useInsuranceStats = (params?: InsuranceFilterParams) => {
  return useQuery({
    queryKey: [INSURANCE_QUERY_KEY.STATS, params],
    queryFn: () => getInsuranceStats(params),
    enabled: Boolean(params?.year),
  });
};
